<template lang="html">
  <div>
    <!-- 
    Previous method with a download button.  
    <b-btn v-show="!url" variant="primary" @click="get_url_and_download">
      Download Video <v-icon name="download" class="ml-1" />
    </b-btn>
    <span v-show="url" class="small">
      Downloading ... (<b-link :href="url">Temporary direct link</b-link>)
    </span> -->
    <span v-show="!url">
      Generating download link ...
    </span>
    <div>
      <p v-show="url">
        <b-link :href="url">Temporary download link</b-link>
      </p>
      <p v-show="url" class="small">
        Note: In Firefox, by default, when you click on a linked video file, it will try to open and play the video using its built-in media player.
        You may need to right-click (ctrl-click) on the link above and choose "Save Link As" or "Download Link" (the exact wording may vary depending on your Firefox version and operating system).
        Clicking this option will open a file dialog that allows you to choose where you want to save the video file on your computer.
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DownloadButtonVideo",
  props: {
    item_key: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      url: null,
      url_requested: false,
    };
  },
  mounted() {
    this.get_url_link();
  },
  methods: {
    get_url_link() {
      var _v = this;
      axios
        .post("https://upload.soundslides.com/generate_url/v3/", {
          key: this.item_key,
        })
        .then(function(response) {
          console.log(response.data.url);
          var url = response.data.url;
          _v.url = url;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    get_url_and_download() {
      var _v = this;
      axios
        .post("https://upload.soundslides.com/generate_url/v3/", {
          key: this.item_key,
        })
        .then(function(response) {
          console.log(response.data.url);
          var url = response.data.url;
          _v.url = url;
          window.location = response.data.url;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
